module.exports = __webpack_public_path__ + "static/media/flatbread-banner-vector.eb1989f6.svg";